<template>
    <div>
        <div id="header-container" class="px-5 in-step">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white mb-4">
                <h3 class="text-white">{{ $t('Set Payment Password') }}</h3>
                <span class="fz-16 fw-400">{{ $t('Set your secure payment credentials, ensuring your account remains protected during transactions') }}</span>
            </div>
        </div>

        <b-container fluid class="mt-0 pb-5">
            <div id="body-container" class="py-5">
                <b-row>
                    <b-col cols="12" xl="7" class="p-5 ml-auto">
                        <h4 class="mb-3">{{ $t('Set Payment Password') }}</h4>
                        <div class="text-grey2 mb-4 d-block ml-1">{{ $t('Please create your new payment password, it should be 6 digit') }}.</div>

                        <div class="d-flex mb-4 pr-5">
                            <input type="text" class="form-control mr-2 fz-24 fw-500 text-center" v-for="index in 6" maxlength="1" @input="onInput" v-on:keydown="onKeyDown" v-model="pin[index-1]">
                        </div>
                        <div class="text-danger">{{ $t(error.password) }}</div>
                    </b-col>
                    <b-col cols="12" xl="5" class="px-5">
                        <img :src="`${publicPath}img/gep/payment-password.svg`" class="w-100"/>
                    </b-col>
                </b-row>
                <b-row class="mt-5 mx-5">
                    <b-col cols="12" class="d-flex">
                        <button @click="submit" class="btn btn-primary d-block ml-auto">{{ $t('Submit') }}</button>
                    </b-col>
                </b-row>
            </div>
      </b-container>
      <LoaderComponent v-if="isLoading"></LoaderComponent>
    </div>
  </template>
  <script>
  
    import LoaderComponent from "@/components/LoaderComponent";
    import stepContainer from "@/components/CardManagement/stepContainer";
    import Common from "@/services/Common";
  
    export default {
        name: 'change-payment-password',
        data() {
            return {
                publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
                isLoading : false,
                stepList:["Old Payment Password","New Payment Password", "Repeat Password"],
                pin:['','','','','',''],
                show_password:false,
                password:'',
                error:{
                    password:''
                }
            }
        },
        components: {
            LoaderComponent,
            stepContainer
        },
        methods:{
            toggleShow(name) {
                this["show_"+name] = !this["show_"+name];
            },
            onChange(name){
                this.error[name]="";
            },
            onKeyDown(e){
                if(e.keyCode==8 && !e.target.value && e.target.previousSibling){
                    this.error.password = '';
                    e.target.previousSibling.focus();
                }
            },
            onInput(e){
                if(e.target && e.data && e.target.nextSibling){
                    e.target.nextSibling.focus();
                }
            },
            getMessage: function (key) {
            return this.$t(key)
            },
            submit(){
                const join = this.pin.join("");
               if(join==''){
                this.error.password = 'can not be blank.';
               }
               else if(join.length!=6){
                this.error.password = 'should be 6 digit.';
               }
               else if(join.length==6){
                this.savePin();
               }
            },
            savePin(){
                this.isLoading = true;
                Common.set_payment_password({
                    "securitycode":this.pin.join(""),
                    }).then(response=>{
                    if(response.status==200){
                        this.isLoading = false;
                        this.$swal({
                            icon: 'success',
                            title: this.getMessage('Success'),
                            showConfirmButton: true,
                        }).then((result) => {
                            window.location.href = location.protocol+"//"+window.location.hostname;
                        });
                    }
                    }).catch(err => {
                        this.isLoading = false;
                        this.checkError(err);
                });
            },
            checkError(err){
                try{
                    const response = err.response;  
                    if(response.status == 401 && response.data.name == "Unauthorized"){
                            localStorage.removeItem("token");
                            localStorage.removeItem("member");
                            localStorage.removeItem("isFirstTime");
                            this.$router.push({ 
                            path: '/login', 
                            });
                        }
                    else{
                    if(localStorage.getItem("token")){
                        var msg = (response.data)?response.data.message:err.message;
                        this.$notify({
                        type: 'warn',
                        text: msg
                        })
                    }
                    }
                }catch(e){
                    console.log(err);
                }
            }
        },
        mounted(){
            
        }
    };
  </script>

<style scoped>
/* General Styling */
ul li {
  list-style: disc;
}

.account-type:hover {
  background: linear-gradient(90deg, #00aeef 0%, #0972d3 100%) !important;
}

.block-item {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

/* Responsiveness */
@media (max-width: 768px) {
  .d-flex.mb-4.flex-wrap {
    padding-right: 0;
    justify-content: center;
  }

  .form-control {
    width: 50px;
    margin-right: 8px;
    font-size: 20px;
  }
}

@media (max-width: 576px) {
  .form-control {
    width: 40px;
    margin-right: 4px;
    font-size: 16px;
  }
}
</style>
